import { render, staticRenderFns } from "./ImprintCityPriceBreakdown.vue?vue&type=template&id=a565618a&scoped=true"
import script from "./ImprintCityPriceBreakdown.vue?vue&type=script&lang=js"
export * from "./ImprintCityPriceBreakdown.vue?vue&type=script&lang=js"
import style0 from "./ImprintCityPriceBreakdown.vue?vue&type=style&index=0&id=a565618a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a565618a",
  null
  
)

export default component.exports